import "./style"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import BottomBarContent from "admin/components/layout/bottom-bar/content"
import memo from "set-state-compare/build/memo.js"
import {useNavigate} from "react-router-dom"

export default memo(shapeComponent(class AdminComponentsLayoutBottomBarAction extends ShapeComponent {
  static defaultProps = {
    disabled: false
  }

  static propTypes = {
    disabled: PropTypes.bool.isRequired,
    icon: PropTypes.string.isRequired,
    label: PropTypes.string,
    onClick: PropTypes.func,
    to: PropTypes.string
  }

  navigate = this.hookField()

  setup() {
    this.navigate = useNavigate()
  }

  onClick = (...args) => {
    const {onClick, to} = this.props

    if (onClick) onClick(...args)
    if (to) this.tt.navigate(to)
  }

  render() {
    const {className, disabled, icon, label, onClick, to, ...restProps} = this.props

    return (
      <BottomBarContent className={classNames("admin-components-layout-bottom-bar-action", className)} onClick={this.onClick} {...restProps}>
        <Icon disabled={disabled} icon={icon} size="small" tooltip={label} />
        <div className="action-label">
          {label}
        </div>
      </BottomBarContent>
    )
  }
}))
